import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import MainButton from '../../buttons/MainButton';

const LoginForm = ({ email, setEmail, password, setPassword, onSubmit, error, loading }) => {
    const { t } = useTranslation();

    return (
        <Form onSubmit={onSubmit}>
            <FormGroup>
                <label>{t('LoginPage.email_label')}</label>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                />
            </FormGroup>
            <FormGroup>
                <label>{t('LoginPage.password_label')}</label>
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                />
            </FormGroup>
            {error && <ErrorMessage>{error}</ErrorMessage>}
            <MainButton type="submit" style={{ marginTop: '10px' }} $loading={loading}>
                {t('LoginPage.login_button')}
            </MainButton>
        </Form>
    );
};

const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    margin-top: 1.5rem;
`;

const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    label {
        font-size: 0.875rem;
        font-weight: 600;
        color: #374151;
    }

    input {
        padding: 0.75rem 1rem;
        border: 1.5px solid #e5e7eb;
        border-radius: 10px;
        font-size: 0.95rem;
        outline: none;
        transition: all 0.2s ease;
        background: #f9fafb;

        &:focus {
            border-color: rgba(130, 22, 146, 0.5);
            background: #fff;
            box-shadow: 0 0 0 4px rgba(130, 22, 146, 0.1);
        }

        &::placeholder {
            color: #9ca3af;
        }
    }
`;

const ErrorMessage = styled.div`
    color: #dc2626;
    font-size: 0.8125rem;
    background: #fef2f2;
    padding: 0.75rem;
    border-radius: 8px;
    border: 1px solid #fecaca;
`;

export default LoginForm;
